import { buildNutritionEditorActionItems } from "../../shared/nutritionEditorActions";

export function buildNutritionPlanEditorActionItems({
  t,
  syncStatus = null,
  includeDuplicate = false,
  includeDelete = false,
  isExportingPdf = false,
} = {}) {
  return buildNutritionEditorActionItems({
    t,
    syncStatus,
    includeDuplicate,
    includeDelete,
    includeExportPdf: true,
    isExportingPdf,
  });
}
